import { FilterModalTextInput } from './FilterModal';
import { ModalFilterProps } from './ModalFilterProps';
import { useOnChangeTextFilter } from './useOnChangeTextFilter';

export const ManufacturerFilter = <T extends { manufacturerFilter?: string | undefined }>({
    localFilters,
    setLocalFilters,
}: ModalFilterProps<T>) => {
    const handleChange = useOnChangeTextFilter<T>('manufacturerFilter', setLocalFilters);
    return (
        <FilterModalTextInput
            id="manufacturer-filter"
            headerMessageId="outboundOrderBook.common.filter.manufacturer"
            inputAddon="rioglyph rioglyph-factory"
            placeholderMessageId="outboundOrderBook.common.filter.enterManufacturer"
            isOptional
            value={localFilters.manufacturerFilter}
            onChange={handleChange}
        />
    );
};
